import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Dropdown, SearchInput } from '@ds/react-components';

const styles = (theme) => ({
  searchContainer: {
    marginBottom: '16px',
  },
});

const SsoRoleListFilter = (props) => {
  const {
    classes,
    onSearchFilterChange,
    onSearchKeywordChange,
    onSearchClick,
  } = props;

  return (
    <div className={classes.searchContainer}>
      <Grid name="searchSection">
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Dropdown
              name={'searchFilter'}
              onChange={onSearchFilterChange}
              placeholder={'All permissions'}
              defaultValue={1}
              options={[
                {
                  label: 'All permissions',
                  value: 1,
                },
                {
                  label: 'Assigned permisions',
                  value: 2,
                },
                {
                  label: 'Unassigned permisions',
                  value: 3,
                },
              ]}
            />
          </Grid>
          <Grid item xs={4}>
            <SearchInput
              name={'searchKeyword'}
              placeholder={'Search'}
              onChange={onSearchKeywordChange}
              adornment={
                <SearchInput.SearchIconButton
                  variant="secondary"
                  onClick={onSearchClick}
                />
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

SsoRoleListFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  onSearchFilterChange: PropTypes.func.isRequired,
  onSearchKeywordChange: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SsoRoleListFilter);
